import { useSubscribedState } from 'nordic/page/store';

export const useIsFade = () => useSubscribedState().layoutFade.isFade;
